import * as React from "react"
export const CloseIcon = (props) => (
  <svg
    width={18}
    height={18}
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M14.68 3.13 3.09 14.87m0-11.74 11.59 11.74'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
